module.exports = __webpack_public_path__ + "img/contacts-header-bg-mobile.315bd28e.png";